// import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import { Card, CardHeader, Heading, CardBody, Flex, Box, useColorModeValue } from '@chakra-ui/react';
// import ReactApexChart from 'react-apexcharts';
// import { truncateText, formatIndianAmount } from 'utils/util';
// import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';

// const TopFiveSalesAndPurchase = ({ title, data, height, datePartyWiseSalesRange, setPartyWiseSalesDateRange }) => {
//    const textColor = useColorModeValue('gray.600', 'white');
//    const legendTextColor = useColorModeValue('#333', 'white');
//    const chartLabelColor = useColorModeValue('#333', 'white');

//    const getChartOptions = useCallback(
//       () => ({
//          chart: {
//             type: 'donut',
//          },
//          labels: [],
//          legend: {
//             labels: {
//                colors: legendTextColor,
//             },
//          },
//          plotOptions: {
//             pie: {
//                donut: {
//                   labels: {
//                      show: true,
//                      name: {
//                         color: chartLabelColor,
//                      },
//                      value: {
//                         color: chartLabelColor,
//                      },
//                      total: {
//                         color: chartLabelColor,
//                      },
//                   },
//                },
//             },
//          },
//          responsive: [
//             {
//                breakpoint: 480,
//                options: {
//                   chart: {
//                      width: 200,
//                   },
//                   legend: {
//                      position: 'bottom',
//                   },
//                },
//             },
//          ],
//       }),
//       [legendTextColor, chartLabelColor],
//    );

//    const [state, setState] = useState({
//       series: [],
//       options: getChartOptions(),
//    });

//    const dateRange = [datePartyWiseSalesRange?.fromDate || '', datePartyWiseSalesRange?.toDate || ''];

//    const handleDateRangeChange = (dates) => {
//       if (!dates || dates.length !== 2) return;

//       const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

//       setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
//    };

//    const total = useMemo(() => {
//       return data?.reduce((acc, item) => acc + Number(item?.amount || 0), 0);
//    }, [data]);
//    const amountHtml = `₹ ${formatIndianAmount(total)}`;

//    useEffect(() => {
//       if (!data || data.length === 0) return;

//       // Group and aggregate "Other" contributors
//       const processedData = [];
//       let otherTotalAmount = 0;
//       let otherTotalPercentage = 0;
//       const otherLabel = 'Other';

//       data.forEach((item) => {
//          if (item.contributor === 'Other') {
//             otherTotalAmount += Number(item.amount);
//             otherTotalPercentage += Number(item.percentage);
//          } else {
//             processedData.push(item);
//          }
//       });

//       if (otherTotalAmount > 0) {
//          processedData.push({
//             contributor: 'Other',
//             rank: '',
//             party: otherLabel,
//             amount: otherTotalAmount,
//             percentage: otherTotalPercentage.toFixed(2),
//          });
//       }

//       const series = processedData.map((item) => Number(item?.percentage));
//       const labels = processedData.map((item) => item?.party);

//       setState((prevState) => ({
//          series,
//          options: {
//             ...getChartOptions(),
//             labels,
//             legend: {
//                ...getChartOptions().legend,
//                formatter: function (seriesName, opts) {
//                   const item = processedData[opts.seriesIndex];
//                   return `<div style="margin-left: 10px; color: ${legendTextColor}">
//                             <span style="font-weight: bold; font-size: 13px;">${truncateText(
//                                item.party.toUpperCase(),
//                                15,
//                             )}</span><br/>
//                             <span>₹${item.amount} (${item.percentage}%)</span>
//                           </div>`;
//                },
//             },
//          },
//       }));
//    }, [data, legendTextColor, getChartOptions]);

//    // This effect will update the chart colors when color mode changes
//    useEffect(() => {
//       setState((prev) => ({
//          ...prev,
//          options: {
//             ...prev.options,
//             legend: {
//                ...prev.options.legend,
//                labels: {
//                   colors: legendTextColor,
//                },
//             },
//             plotOptions: {
//                pie: {
//                   donut: {
//                      labels: {
//                         name: {
//                            color: chartLabelColor,
//                         },
//                         value: {
//                            color: chartLabelColor,
//                         },
//                         total: {
//                            color: chartLabelColor,
//                         },
//                      },
//                   },
//                },
//             },
//          },
//       }));
//    }, [legendTextColor, chartLabelColor]);

//    return (
//       <Card h={height}>
//          <CardHeader>
//             <Flex justifyContent="space-between" alignItems="center" width="100%">
//                <Box>
//                   <Heading size="md" mb={1} color={textColor}>
//                      {title}
//                   </Heading>
//                   <Box
//                      style={{
//                         fontWeight: 'normal',
//                         fontSize: '18px',
//                         color: textColor,
//                      }}
//                      dangerouslySetInnerHTML={{ __html: amountHtml }}
//                   />
//                </Box>
//                <PeriodDatePicker
//                   value={[new Date(datePartyWiseSalesRange?.fromDate), new Date(datePartyWiseSalesRange?.toDate)]}
//                   onChange={handleDateRangeChange}
//                   style={{ width: 250, marginLeft: 40 }}
//                />
//             </Flex>
//          </CardHeader>

//          <CardBody>
//             <ReactApexChart
//                options={state?.options}
//                series={state?.series}
//                type="donut"
//                height={350}
//                key={`chart-${legendTextColor}-${chartLabelColor}`}
//             />
//          </CardBody>
//       </Card>
//    );
// };

// export default TopFiveSalesAndPurchase;

import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Card, CardHeader, Heading, CardBody, Flex, Box, useColorMode } from '@chakra-ui/react';
import ReactApexChart from 'react-apexcharts';
import { truncateText, formatIndianAmount } from 'utils/util';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { RotateCw } from 'lucide-react';

const TopFiveSalesAndPurchase = ({
   title,
   data,
   height,
   datePartyWiseSalesRange,
   setPartyWiseSalesDateRange,
   reload,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [isRotating, setIsRotating] = useState(false);

   const textColor = isDark ? 'white' : 'gray.700';
   const subTextColor = isDark ? 'gray.400' : 'gray.600';
   const legendTextColor = isDark ? '#ffffff' : '#1a202c';
   const chartLabelColor = isDark ? '#ffffff' : '#2d3748';
   const bgColor = isDark ? 'gray.800' : 'white';
   const borderColor = isDark ? 'gray.700' : 'gray.200';
   const accentColor = isDark ? 'blue.400' : 'blue.500';

   const getChartOptions = useCallback(
      (processedData = []) => ({
         chart: {
            type: 'radialBar',
            fontFamily: 'Inter, system-ui, sans-serif',
            height: height || 450, // Added explicit height
            toolbar: {
               show: false,
            },
            animations: {
               enabled: true,
               easing: 'easeinout',
               speed: 800,
               animateGradually: {
                  enabled: true,
                  delay: 150,
               },
               dynamicAnimation: {
                  enabled: true,
                  speed: 350,
               },
            },
         },
         plotOptions: {
            radialBar: {
               offsetY: 0,
               startAngle: 0,
               endAngle: 270,
               hollow: {
                  margin: 5,
                  size: '35%',
                  background: 'transparent',
               },
               dataLabels: {
                  name: {
                     show: true,
                     fontSize: '14px',
                     fontWeight: 600,
                     color: chartLabelColor,
                     offsetY: -10,
                  },
                  value: {
                     show: true,
                     fontSize: '16px',
                     fontWeight: 700,
                     color: chartLabelColor,
                     offsetY: -5,
                     formatter: function (val) {
                        return Number(val).toFixed(1) + '%';
                     },
                  },
                  total: {
                     show: true,
                     label: 'Total',
                     fontSize: '14px',
                     fontWeight: 600,
                     color: chartLabelColor,
                     formatter: function (w) {
                        const total = processedData.reduce((acc, item) => acc + Number(item.amount || 0), 0);
                        const formatted = new Intl.NumberFormat('en-IN', {
                           maximumFractionDigits: 2,
                           minimumFractionDigits: 2,
                        }).format(total);
                        return '₹' + formatted;
                     },
                  },
               },
               track: {
                  background: isDark ? '#374151' : '#f3f4f6',
                  strokeWidth: '100%',
                  opacity: 1,
                  margin: 8,
               },
            },
         },
         colors: ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#14B8A6', '#F97316'],
         labels: processedData.map((item) => item?.party || ''),
         legend: {
            show: true,
            floating: false,
            position: 'right',
            offsetX: -10,
            offsetY: 0,
            fontSize: '14px',
            fontWeight: 500,
            labels: {
               colors: legendTextColor,
               useSeriesColors: false,
            },
            markers: {
               width: 12,
               height: 12,
               radius: 3,
            },
            itemMargin: {
               horizontal: 10,
               vertical: 8,
            },
            formatter: function (seriesName, opts) {
               const item = processedData[opts.seriesIndex];
               if (!item) return seriesName;
               return `<div style="display: flex; flex-direction: column; padding: 4px 0;">
                         <span style="font-weight: 600; font-size: 14px; color: ${legendTextColor}; margin-bottom: 2px;">
                           ${truncateText(item.party.toUpperCase(), 18)}
                         </span>
                         <span style="font-size: 13px; color: ${isDark ? '#9ca3af' : '#6b7280'}; font-weight: 500;">
                           ₹${formatIndianAmount(item.amount)}
                         </span>
                         <span style="font-size: 12px; color: ${isDark ? '#9ca3af' : '#6b7280'};">
                           ${Number(item.percentage).toFixed(2)}% of total
                         </span>
                       </div>`;
            },
         },
         stroke: {
            lineCap: 'round',
         },
         tooltip: {
            enabled: true,
            theme: isDark ? 'dark' : 'light',
            style: {
               fontSize: '13px',
            },
            y: {
               formatter: function (val, opts) {
                  const item = processedData[opts.seriesIndex];
                  return item ? `₹${formatIndianAmount(item?.amount)} (${Number(item?.percentage).toFixed(2)}%)` : val;
               },
            },
         },
         responsive: [
            {
               breakpoint: 1440,
               options: {
                  chart: {
                     height: 380,
                  },
                  legend: {
                     position: 'right',
                     offsetX: -5,
                     offsetY: 0,
                     fontSize: '13px',
                     itemMargin: {
                        horizontal: 8,
                        vertical: 6,
                     },
                  },
                  plotOptions: {
                     radialBar: {
                        hollow: {
                           size: '35%',
                        },
                        dataLabels: {
                           name: {
                              fontSize: '13px',
                           },
                           value: {
                              fontSize: '15px',
                           },
                           total: {
                              fontSize: '13px',
                           },
                        },
                     },
                  },
               },
            },
            {
               breakpoint: 1200,
               options: {
                  chart: {
                     height: 360,
                  },
                  legend: {
                     position: 'bottom',
                     offsetY: 5,
                     offsetX: 0,
                     fontSize: '12px',
                     itemMargin: {
                        horizontal: 8,
                        vertical: 5,
                     },
                     formatter: function (seriesName, opts) {
                        const item = processedData[opts.seriesIndex];
                        if (!item) return seriesName;
                        return `<div style="display: flex; flex-direction: column; padding: 2px 0;">
                                  <span style="font-weight: 600; font-size: 12px; color: ${legendTextColor};">
                                    ${truncateText(item.party.toUpperCase(), 15)}
                                  </span>
                                  <span style="font-size: 11px; color: ${isDark ? '#9ca3af' : '#6b7280'};">
                                    ₹${formatIndianAmount(item.amount)} (${Number(item.percentage).toFixed(1)}%)
                                  </span>
                                </div>`;
                     },
                  },
                  plotOptions: {
                     radialBar: {
                        hollow: {
                           size: '40%',
                        },
                        dataLabels: {
                           name: {
                              fontSize: '12px',
                              offsetY: -8,
                           },
                           value: {
                              fontSize: '14px',
                              offsetY: -4,
                           },
                           total: {
                              fontSize: '12px',
                           },
                        },
                     },
                  },
               },
            },
            {
               breakpoint: 1024,
               options: {
                  chart: {
                     height: 340,
                  },
                  legend: {
                     position: 'bottom',
                     offsetY: 5,
                     fontSize: '11px',
                     itemMargin: {
                        horizontal: 6,
                        vertical: 4,
                     },
                     formatter: function (seriesName, opts) {
                        const item = processedData[opts.seriesIndex];
                        if (!item) return seriesName;
                        return `<div style="display: flex; flex-direction: column; padding: 2px 0;">
                                  <span style="font-weight: 600; font-size: 11px; color: ${legendTextColor};">
                                    ${truncateText(item.party.toUpperCase(), 12)}
                                  </span>
                                  <span style="font-size: 10px; color: ${isDark ? '#9ca3af' : '#6b7280'};">
                                    ₹${formatIndianAmount(item.amount)}
                                  </span>
                                </div>`;
                     },
                  },
                  plotOptions: {
                     radialBar: {
                        hollow: {
                           size: '40%',
                           margin: 3,
                        },
                        dataLabels: {
                           name: {
                              fontSize: '11px',
                              offsetY: -8,
                           },
                           value: {
                              fontSize: '13px',
                              offsetY: -4,
                           },
                           total: {
                              fontSize: '11px',
                              formatter: function (w) {
                                 const total = processedData.reduce((acc, item) => acc + Number(item.amount || 0), 0);
                                 const formatted = new Intl.NumberFormat('en-IN', {
                                    maximumFractionDigits: 0,
                                 }).format(total);
                                 return '₹' + formatted;
                              },
                           },
                        },
                        track: {
                           margin: 6,
                        },
                     },
                  },
               },
            },
            {
               breakpoint: 768,
               options: {
                  chart: {
                     height: 320,
                  },
                  legend: {
                     position: 'bottom',
                     offsetY: 5,
                     fontSize: '10px',
                     itemMargin: {
                        horizontal: 5,
                        vertical: 3,
                     },
                     formatter: function (seriesName, opts) {
                        const item = processedData[opts.seriesIndex];
                        if (!item) return seriesName;
                        return `<span style="font-weight: 600; font-size: 10px; color: ${legendTextColor};">
                                  ${truncateText(item.party.toUpperCase(), 10)} - ${Number(item.percentage).toFixed(1)}%
                                </span>`;
                     },
                  },
                  plotOptions: {
                     radialBar: {
                        hollow: {
                           size: '45%',
                           margin: 2,
                        },
                        dataLabels: {
                           name: {
                              fontSize: '10px',
                              offsetY: -6,
                           },
                           value: {
                              fontSize: '12px',
                              offsetY: -3,
                           },
                           total: {
                              fontSize: '10px',
                              formatter: function (w) {
                                 const total = processedData.reduce((acc, item) => acc + Number(item.amount || 0), 0);
                                 const formatted = new Intl.NumberFormat('en-IN', {
                                    notation: 'compact',
                                    compactDisplay: 'short',
                                 }).format(total);
                                 return '₹' + formatted;
                              },
                           },
                        },
                        track: {
                           margin: 5,
                        },
                     },
                  },
               },
            },
            {
               breakpoint: 640,
               options: {
                  chart: {
                     height: 300,
                  },
                  legend: {
                     position: 'bottom',
                     offsetY: 0,
                     fontSize: '9px',
                     itemMargin: {
                        horizontal: 4,
                        vertical: 2,
                     },
                     markers: {
                        width: 8,
                        height: 8,
                     },
                     formatter: function (seriesName, opts) {
                        const item = processedData[opts.seriesIndex];
                        if (!item) return seriesName;
                        return `<span style="font-size: 9px; color: ${legendTextColor};">
                                  ${truncateText(item.party, 8)} - ${Number(item.percentage).toFixed(0)}%
                                </span>`;
                     },
                  },
                  plotOptions: {
                     radialBar: {
                        hollow: {
                           size: '50%',
                           margin: 2,
                        },
                        dataLabels: {
                           name: {
                              fontSize: '9px',
                              offsetY: -5,
                           },
                           value: {
                              fontSize: '11px',
                              offsetY: -2,
                           },
                           total: {
                              fontSize: '9px',
                              label: 'Total',
                              formatter: function (w) {
                                 const total = processedData.reduce((acc, item) => acc + Number(item.amount || 0), 0);
                                 const formatted = new Intl.NumberFormat('en-IN', {
                                    notation: 'compact',
                                    compactDisplay: 'short',
                                 }).format(total);
                                 return '₹' + formatted;
                              },
                           },
                        },
                        track: {
                           margin: 4,
                        },
                     },
                  },
               },
            },
            {
               breakpoint: 480,
               options: {
                  chart: {
                     height: 280,
                  },
                  legend: {
                     position: 'bottom',
                     offsetY: 0,
                     fontSize: '8px',
                     itemMargin: {
                        horizontal: 3,
                        vertical: 2,
                     },
                     markers: {
                        width: 7,
                        height: 7,
                     },
                     formatter: function (seriesName, opts) {
                        const item = processedData[opts.seriesIndex];
                        if (!item) return seriesName;
                        return `<span style="font-size: 8px; color: ${legendTextColor};">
                                  ${truncateText(item.party, 6)}
                                </span>`;
                     },
                  },
                  plotOptions: {
                     radialBar: {
                        startAngle: 0,
                        endAngle: 360,
                        hollow: {
                           size: '55%',
                           margin: 1,
                        },
                        dataLabels: {
                           name: {
                              show: false,
                           },
                           value: {
                              show: false,
                           },
                           total: {
                              show: true,
                              fontSize: '10px',
                              label: 'Total',
                              formatter: function (w) {
                                 const total = processedData.reduce((acc, item) => acc + Number(item.amount || 0), 0);
                                 const formatted = new Intl.NumberFormat('en-IN', {
                                    notation: 'compact',
                                 }).format(total);
                                 return '₹' + formatted;
                              },
                           },
                        },
                        track: {
                           margin: 3,
                        },
                     },
                  },
               },
            },
         ],
      }),
      [legendTextColor, chartLabelColor, isDark, height],
   );

   const [state, setState] = useState({
      series: [],
      options: getChartOptions(),
   });

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   };

   const total = useMemo(() => {
      return data?.reduce((acc, item) => acc + Number(item?.amount || 0), 0);
   }, [data]);

   const topContributor = useMemo(() => {
      if (!data || data.length === 0) return null;
      return data.reduce((max, item) => (Number(item?.amount) > Number(max?.amount) ? item : max), data[0]);
   }, [data]);

   useEffect(() => {
      if (!data || data.length === 0) {
         setState({
            series: [],
            options: getChartOptions([]),
         });
         return;
      }

      const processedData = [];
      let otherTotalAmount = 0;
      let otherTotalPercentage = 0;

      data.forEach((item) => {
         if (item.contributor === 'Other') {
            otherTotalAmount += Number(item.amount || 0);
            otherTotalPercentage += Number(item.percentage || 0);
         } else {
            processedData.push({
               ...item,
               amount: Number(item.amount || 0),
               percentage: Number(item.percentage || 0),
            });
         }
      });

      if (otherTotalAmount > 0) {
         processedData.push({
            contributor: 'Other',
            rank: '',
            party: 'Other',
            amount: otherTotalAmount,
            percentage: otherTotalPercentage,
         });
      }

      const series = processedData.map((item) => Number(item?.percentage || 0));

      setState({
         series,
         options: getChartOptions(processedData),
      });
   }, [data, getChartOptions]);

   const amountHtml = `₹ ${formatIndianAmount(total)}`;

   const handleReload = async () => {
      setIsRotating(true);
      reload();
      setTimeout(() => setIsRotating(false), 700);
   };

   return (
      <Card
         bg={bgColor}
         borderRadius={{ base: 'lg', md: 'xl' }}
         boxShadow={{ base: 'md', md: 'lg' }}
         border="1px solid"
         borderColor={borderColor}
         transition="all 0.3s"
         _hover={{
            boxShadow: 'xl',
            transform: 'translateY(-2px)',
         }}>
         <CardHeader pb={2} px={{ base: 4, md: 6 }}>
            <Flex justifyContent="space-between" alignItems="flex-start" width="100%" gap={4} flexWrap="wrap">
               <Box flex="1" minW={{ base: '100%', sm: '200px' }}>
                  <Flex alignItems="center" gap={2} mb={2}>
                     <Box w="4px" h={{ base: '20px', md: '24px' }} bg={accentColor} borderRadius="full" />
                     <Heading size={{ base: 'sm', md: 'md' }} color={textColor} fontWeight="700">
                        {title}
                     </Heading>
                  </Flex>

                  <Flex gap={{ base: 4, md: 6 }} mt={3} flexWrap="wrap">
                     <Box>
                        <Box fontSize="xs" color={subTextColor} fontWeight="500" mb={1}>
                           Total Amount
                        </Box>
                        <Box
                           fontSize={{ base: '16px', md: '18px' }}
                           fontWeight="600"
                           color={textColor}
                           dangerouslySetInnerHTML={{ __html: amountHtml }}
                        />
                     </Box>
                  </Flex>
               </Box>

               <Box w={{ base: '100%', sm: 'auto' }} mt={{ base: 2, sm: 0 }} display="flex">
                  <PeriodDatePicker
                     value={[new Date(datePartyWiseSalesRange?.fromDate), new Date(datePartyWiseSalesRange?.toDate)]}
                     onChange={handleDateRangeChange}
                     style={{ width: '100%', maxWidth: 250 }}
                  />

                  <button
                     onClick={handleReload}
                     className={`ml-2 p-2 rounded-full transition-all duration-300 hover:scale-110 ${
                        isDark ? 'hover:bg-gray-700 text-blue-400' : 'hover:bg-gray-100 text-blue-600'
                     }`}>
                     <RotateCw
                        className={`w-5 h-5 transform ${
                           isRotating ? 'rotate-[360deg]' : ''
                        } transition-transform ease-in-out`}
                        style={{
                           transitionDuration: isRotating ? '700ms' : '10ms',
                        }}
                     />
                  </button>
               </Box>
            </Flex>
         </CardHeader>

         <CardBody pt={2}>
            {data && data.length > 0 ? (
               <ReactApexChart
                  options={state?.options}
                  series={state?.series}
                  type="radialBar"
                  height={350}
                  key={`chart-${isDark ? 'dark' : 'light'}`}
               />
            ) : (
               <Flex
                  h={{ base: '280px', md: height || 450 }}
                  alignItems="center"
                  justifyContent="center"
                  color={subTextColor}
                  fontSize={{ base: 'sm', md: 'md' }}
                  fontWeight="500"
                  px={4}
                  textAlign="center">
                  {data && data.length > 0 ? 'Loading chart...' : 'No data available for the selected period'}
               </Flex>
            )}
         </CardBody>
      </Card>
   );
};

export default TopFiveSalesAndPurchase;
